import { MakeCall } from './createMakeCall';

export interface Payload {
  email: string;
}

const recoverAccount = (makeCall: MakeCall) => (data: Payload) =>
  makeCall<undefined>('POST', `/api/v2/action/forgot-password`, { data });
export { recoverAccount };
